import { lazy } from "react";
import { BiSliderAlt } from "react-icons/bi";
import { FaBuilding, FaBullhorn, FaCar, FaChargingStation, FaFileAlt, FaMoneyBillAlt, FaPhone, FaRegStar, FaSitemap, FaTh } from "react-icons/fa";
import { HiOutlineTicket, HiUserGroup, HiUsers } from "react-icons/hi";
import { RiGroupLine } from "react-icons/ri";

export const menuItems = [
  {
    name: "",
    item: [
      {
        id: "dashboard",
        name: "dashboard",
        path: "/dashboard",
        icon: <FaTh />,
      },
      {
        id: "sales-order",
        name: "sale_order",
        path: "/sale-order",
        icon: <FaFileAlt />,
      },
      {
        id: "sale_order_payback",
        name: "sale_order_payback",
        path: "/sale-order-payback",
        icon: <FaFileAlt />,
      },
    ],
  },
  {
    name: "report",
    item: [
      {
        moduleName: "Report Sales Order (View)",
        name: "sale_order",
        path: "/report-sale-order",
        icon: <FaFileAlt />,
      },
      {
        moduleName: "Transaction Wallet (View)",
        name: "customer_transaction",
        path: "/customer-transaction",
        icon: <FaFileAlt />,
      },
      {
        moduleName: "Report Sales Order (View)",
        name: "customer_app_report",
        path: "/customer-app-report",
        icon: <FaFileAlt />,
      },
    ],
  },
  {
    name: "crm",
    item: [
      {
        id: "franchise",
        name: "franchise",
        path: "/franchise",
        icon: <FaSitemap />,
      },
      {
        id: "agent",
        name: "agent",
        path: "/agent",
        icon: <HiUserGroup />,
      },
      {
        id: "customer_category",
        name: "customer_category",
        path: "/customer_category",
        icon: <RiGroupLine />,
      },
      {
        id: "customer",
        name: "customer",
        path: "/customer",
        icon: <RiGroupLine />,
      },
      {
        id: "promotion",
        name: "promotion",
        path: "/promotion",
        icon: <FaBullhorn />,
      },
      {
        id: "membership",
        name: "membership",
        path: "/membership",
        icon: <FaRegStar />,
      },
      {
        id: "voucher",
        name: "voucher_generate",
        path: "/voucher-generate",
        icon: <HiOutlineTicket />,
      }
    ],
  },
  {
    name: "driver_setting",
    item: [
      {
        id: "company",
        name: "company",
        path: "/company",
        icon: <FaBuilding />,
      },
      {
        id: "driver_type",
        name: "driver_type",
        path: "/driver-type",
        icon: <FaCar />,
      },
      {
        id: "driver_category",
        name: "driver_category",
        path: "/driver-category",
        icon: <FaCar />,
      },
      {
        id: "driver",
        name: "driver",
        path: "/driver",
        icon: <FaCar />,
      },
    ],
  },
  {
    name: "system_setting",
    item: [
      {
        id: "driver",
        name: "customer_app",
        path: "/customer-app",
        icon: <FaPhone />,
      },
      {
        id: "station",
        name: "station",
        path: "/station",
        icon: <FaBuilding />,
      },
      {
        id: "charger-account",
        name: "charger_account",
        path: "/charger-account",
        icon: <FaChargingStation />,
      },
      {
        id: "charger-price",
        name: "charger_price",
        path: "/charger-price",
        icon: <FaMoneyBillAlt />,
      },
      {
        id: "system-roles",
        name: "system_role",
        path: "/system-role",
        icon: <BiSliderAlt />,
      },
      {
        id: "users",
        name: "user",
        path: "/user",
        icon: <HiUsers />,
      },
    ],
  },
];

export const menuItemsCustomerApp = [
  {
    id: "kwh-setting",
    name: "faq_setting",
    path: "faq-setting",
    component: lazy(() => import("../../view/app/system-setting/customer-app/faq-setting")),
  },
  {
    id: "price-setting",
    name: "contact_us_setting",
    path: "contact-us-setting",
    component: lazy(() => import("../../view/app/system-setting/customer-app/contact-us-setting")),
  },
  {
    id: "label-setting",
    name: "privacy_term_setting",
    path: "privacy-term-setting",
    component: lazy(() => import("../../view/app/system-setting/customer-app/privacy-term-setting")),
  },
  {
    id: "video-setting",
    name: "slide_show_setting",
    path: "slide-show-setting",
    component: lazy(() => import("../../view/app/system-setting/customer-app/slide-show-setting")),
  },
  {
    id: "video-setting",
    name: "new_feed_setting",
    path: "new-feed-setting",
    component: lazy(() => import("../../view/app/system-setting/customer-app/new-feed-setting")),
  },
];

export const menuItemsChargerPrice = [
  {
    id: "kwh-setting",
    name: "kwh_display_setting",
    component: lazy(() => import("../../view/app/system-setting/charger-price/kwh-display-setting")),
  },
  {
    id: "price-setting",
    name: "price_display_setting",
    component: lazy(() => import("../../view/app/system-setting/charger-price/price-display-setting")),
  },
  {
    id: "label-setting",
    name: "label_display_setting",
    component: lazy(() => import("../../view/app/system-setting/charger-price/label-display-setting")),
  },
  {
    id: "video-setting",
    name: "video_setting",
    component: lazy(() => import("../../view/app/system-setting/charger-price/video-setting")),
  },
];

export const menuItemsMembership = [
  {
    id: "membership",
    name: "membership_card",
    path: "membership-card",
    component: lazy(() => import("../../view/app/crm/membership/membership-card")),
  },
  {
    id: "membership",
    name: "membership_level",
    path: "membership-level",
    component: lazy(() => import("../../view/app/crm/membership/membership-level")),
  },
];

